import type { DialogProfileDto } from "../../types/DialogProfileDto";
import type { DialogProfileEntity } from "../../types/DialogProfileEntity";

export const DialogProfileDtoToEntity = ({ ...rest }: Readonly<DialogProfileDto>): DialogProfileEntity => {
    return { ...rest };
};
